// src/stores/sagas/activity.js
import axios from 'axios'
import { takeLatest, call } from 'redux-saga/effects'
import apiConfig from '@services/apiConfig'
import { LIST_ACTIVITIES, CREATE_ACTIVITY } from '@stores/actions/activity'
import errorHandler from '../errorHandler'

function* listActivitiesWorker({ params, callback }) {
  try {
    const response = yield call(axios, {
      method: 'GET',
      url: `${apiConfig.prefix}/activity`,
      params,
    })
    callback && callback(response.data || [])
  } catch (error) {
    callback && callback([])
    errorHandler(error)
  }
}

function* createActivityWorker({ data, callback }) {
  try {
    const response = yield call(axios, {
      method: 'POST',
      url: `${apiConfig.prefix}/activity`,
      data,
    })
    // Retorna o objeto criado pro modal encerrar o loading
    callback && callback(response.data)
  } catch (error) {
    callback && callback()
    errorHandler(error)
  }
}

export function* listActivitiesSaga() { yield takeLatest(LIST_ACTIVITIES, listActivitiesWorker) }
export function* createActivitySaga() { yield takeLatest(CREATE_ACTIVITY, createActivityWorker) }
